<template>
  <div class="record-container" :class="showRightArrowIcon && 'show-right-arrow-icon'">
    <div class="duration-line" :style="{ height: durationLineLength }"></div>
    <div v-if="statusName" class="status">{{ statusName }}</div>
    <div v-if="interviewTime" class="interview-time">{{ interviewTime }}</div>
    <el-tooltip
      v-if="jobName"
      effect="light"
      popper-class="light-tooltip-popper place-right"
      placement="right"
      :open-delay="300"
      :content="jobName"
    >
      <div class="job-title">{{ jobName }}</div>
    </el-tooltip>
    <div v-if="hiringManagerNames" class="hm">
      <span class="icon">HM</span>
      <el-tooltip
        effect="light"
        popper-class="light-tooltip-popper place-right"
        placement="right"
        :open-delay="300"
        :content="hiringManagerNames"
      >
        <span class="name">{{ hiringManagerNames }}</span>
      </el-tooltip>
    </div>
    <div v-if="candidateNames" class="candidate">
      <span class="icon">C</span>
      <el-tooltip
        effect="light"
        placement="right"
        popper-class="light-tooltip-popper place-right"
        :open-delay="300"
        :content="candidateNames"
      >
        <span class="name" :class="candidateList.length === 1 && 'clickable'" @click="handleCandidateNameClick">{{ candidateNames }}</span>
      </el-tooltip>
      <el-dropdown
        v-if="showOperation"
        class="action-dropdown"
        trigger="click"
        :disabled="isCanceledStatus|| noAction"
        :ref="`actionDropdown_${id}`"
        :hide-on-click="false"
        @command="handelActionClick"
      >
        <span v-if="noAction" v-auto-tooltip.always="disabledTooltip" class="more iconfont icona-xingzhuangbeifen8 disabled" @click.stop></span>
        <span v-else class="more iconfont icona-xingzhuangbeifen8" :class="isCanceledStatus && 'disabled'" @click.stop></span>
        <template #dropdown>
          <el-dropdown-menu>
            <template v-if="status === INTERVIEW_STATUS.PENDING || status === INTERVIEW_STATUS.PARTIALLY_RATED">
              <el-dropdown-item command="reschedule">{{ $t(`${i18nPrefix}.btn.reschedule`) }}</el-dropdown-item>
              <el-dropdown-item command="sendInterviewRating">{{ $t(`${i18nPrefix}.btn.sendInterviewRating`) }}</el-dropdown-item>
            </template>
            <template v-else-if="status === INTERVIEW_STATUS.FINISHED">
              <el-dropdown-item command="sendNew">{{ $t(`${i18nPrefix}.btn.scheduleAnotherInterview`) }}</el-dropdown-item>
            </template>
            <template v-else-if="status === INTERVIEW_STATUS.PENDING_GENERATE_TEAMS_URL || status === INTERVIEW_STATUS.PENDING_GENERATE_TEAMS_EVENT">
              <el-dropdown-item command="confirmInterview">{{ $t(`${i18nPrefix}.btn.interviewConfirm`) }}</el-dropdown-item>
            </template>
            <template v-else>
              <el-dropdown-item v-if="canEdit" command="edit">{{ $t(`${i18nPrefix}.btn.editor`) }}</el-dropdown-item>
              <el-popconfirm :title="$t(`${i18nPrefix}.message.confirmToCancelInterview`)" @confirm="handleCancel">
                <template #reference>
                  <el-dropdown-item command="cancel">{{ $t(`${i18nPrefix}.btn.cancel`) }}</el-dropdown-item>
                </template>
              </el-popconfirm>
            </template>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <div v-if="showRightArrowIcon" class="icon-container">
      <i class="el-icon-caret-right right-arrow-icon"></i>
    </div>
  </div>
</template>

<script>
import { INTERVIEW_CANCELED_STATUS, INTERVIEW_STATUS } from '@/constant/interview'
import _ from 'lodash'

export default {
  props: {
    status: {
      type: Number,
      required: false
    },
    start: {
      type: Number,
      required: false
    },
    end: {
      type: Number,
      required: false
    },
    durationLineLength: {
      required: false,
      default: '100%'
    },
    interviewTime: {
      type: String,
      required: false
    },
    jobName: {
      type: String,
      required: false
    },
    hiringManagerNames: {
      type: String,
      required: false
    },
    candidateNames: {
      type: String,
      required: false
    },
    id: {
      type: String,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: false
    },
    showOperation: {
      type: Boolean,
      default: false
    },
    statusName: {
      type: String,
      required: false
    },
    showRightArrowIcon: {
      type: Boolean,
      default: false
    },
    candidateList: {
      type: Array,
      default: () => []
    },
    noAction: {
      type: Boolean,
      default: false
    },
    disabledTooltip: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      INTERVIEW_STATUS,
      i18nPrefix: 'admin.application.candidate'
    }
  },
  computed: {
    isCanceledStatus () {
      return _.includes(INTERVIEW_CANCELED_STATUS, this.status)
    }
  },
  created () {

  },
  methods: {
    handleEdit () {
      this.$emit('edit')
    },
    handleCancel () {
      this.$emit('cancel')
    },
    handleResend () {
      this.$emit('resend')
    },
    handleSendNew () {
      this.$emit('sendNew')
    },
    handleSendRating () {
      this.$emit('sendRating')
    },
    handleConfirmInterview () {
      this.$emit('confirmInterview')
    },
    handelActionClick (command) {
      if (_.includes(INTERVIEW_CANCELED_STATUS, this.status) || this.noAction) {
        return
      }
      if (command === 'reschedule') {
        this.handleResend()
      }
      if (command === 'sendInterviewRating') {
        this.handleSendRating()
        this.$refs[`actionDropdown_${this.id}`].hide()
      }
      if (command === 'sendNew') {
        this.handleSendNew()
      }
      if (command === 'edit') {
        this.handleEdit()
      }
      if (command === 'confirmInterview') {
        this.handleConfirmInterview()
      }
    },
    handleCandidateNameClick () {
      this.$emit('openCandidateDetail')
    }
  }
}
</script>

<style lang='scss' scoped>
.record-container {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  width: 100%;
  padding: 5px 10px;
  font-size: 12px;
  color: #606266;
  background-color: rgba(0, 150, 204, 0.1);

  .duration-line {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    background: linear-gradient(-45deg, #ffffff 30%, #0096cc 30%, #0096cc 50%, #ffffff 50%, #ffffff 80%, #0096cc 80%);
    background-size: 4px 4px;
  }

  .status {
    font-weight: 500;
    line-height: 17px;
    word-break: break-word;
    text-align: left;
  }

  .interview-time {
    line-height: 17px;
  }

  .job-title {
    flex-shrink: 0;
    padding-right: 12px;
    color: #303133;
    line-height: 17px;
    max-width: 100%;
    width: fit-content;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .hm,
  .candidate {
    margin-top: 2px;
    display: flex;
    align-items: center;
    font-weight: 400;
    color: #606266;

    .icon {
      display: inline-block;
      width: 22px;
      height: 22px;
      line-height: 22px;
      background-color: #008FC3;
      color: #fff;
      font-size: 12px;
      text-align: center;
      flex-shrink: 0;
      border-radius: 2px;
    }

    .name {
      width: max-content;
      display: inline-block;
      margin-left: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.clickable {
        color: #0096cc;
        cursor: pointer;
      }
    }
  }

  .hm {
    margin-bottom: 2px;

    .name {
      padding-right: 12px;
    }
  }

  .candidate {

    .action-dropdown {
      margin-left: auto;

      .more {
        margin-left: auto;
        font-size: 12px;
        color: #909399;
        cursor: pointer;

        &.disabled {
          cursor:not-allowed;
        }
      }
    }

  }

  .icon-container {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 12px;
    width: 18px;
    height: 100%;

    .right-arrow-icon {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &.show-right-arrow-icon {

  }

  &.pending {
    background-color: #fff5eb;

    .duration-line {
      background: #f4a958;
    }

    .status {
      color: #f4a958;
    }
  }

  &.finished {
    background-color: #f0fff7;

    .duration-line {
      background: #51bf82;
    }

    .status {
      color: #51bf82;
    }
  }

  &.partially-rated {
    background-color: #fff5eb;

    .duration-line {
      background: #f4a958;
    }

    .status {
      color: #f4a958;
    }
  }

  &.scheduled {
    background-color: #ecf6ff;

    .status {
      color: #51abff;
    }

    .duration-line {
      background: #51abff;
    }
  }

  &.canceled {
    background-color: #f2f2f2;

    .status {
      color: #606266;
    }

    .duration-line {
      background: #c0c4cc;
    }
  }

  &.has-children {
    width: calc(100% - 20px)
  }
}
</style>
<style lang="scss">
.el-tooltip__popper.is-light.light-tooltip-popper[x-placement].place-right {
  .popper__arrow {
    border-right-color: #e6e6e6;
    border-bottom-color: transparent;
    border-top-color: transparent;

    &::after {
      border-right-color: #e6e6e6;
      border-bottom-color: transparent;
      border-top-color: transparent;
    }
  }
}
</style>
